var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.2136 13.3307L17.8359 9.5693H13.9452V7.12838C13.9452 6.09932 14.4887 5.09624 16.2312 5.09624H18V1.89377C18 1.89377 16.3949 1.63965 14.8602 1.63965C11.656 1.63965 9.56167 3.44121 9.56167 6.70254V9.5693H6V13.3307H9.56167V22.4238H13.9452V13.3307H17.2136Z","fill":"white"}));
}

FacebookInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
